import React from "react";
import { Link } from "react-router-dom";

/**
 * Props:
 * title: string
 * description: string
 * video: string (optional)
 * ctaText: string (optional)
 * ctaLink: string (optional)
 */
const FeatureHeroSection = ({
  title,
  description,
  image,
}) => {
  return (
      <div className="col-12 text-center text-white pt-6indx bg-blue0">
          <h1 className='display-5 mb-3 font-bold page-desc'><b>{title}</b></h1>
          <div className='mb-3 page-desc font15em'>
              {description}
          </div>
          
          <p className='pt-3'>
          <Link className="main-btn btn-hover text-white bg-dark mb-3" to="/seller/register">Get started for free</Link>
          </p>

          <div className='col-12'>                        
              <div className="welcome-banner mt-4 br10">
                  <picture>
                      <img loading="lazy" src={image} alt="..." className="w-100 h-100" />
                  </picture>
              </div>
          </div>
      </div>  
  );
};

export default FeatureHeroSection;


